import OutsydeSDK from "./sdk";

const outsydeSDK = new OutsydeSDK();

export default outsydeSDK;
